import { SKILL_LIST } from "@mathtrain/engine";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function Focus() {
  const nav = useNavigate();
  const loc = useLocation();
  const [len, setLen] = useState<number>((loc.state as any)?.length ?? 20);
  const [picked, setPicked] = useState<Set<string>>(new Set());
  const toggle = (k: string) => { const s = new Set(picked); s.has(k) ? s.delete(k) : s.add(k); setPicked(s); };
  return <main className="page bare">
    <button className="btn quiet" onClick={() => nav(-1)}>‹ Back</button>
    <h1>Focus</h1>
    <p className="mute">Only the skills you pick, still adapting to you.</p>
    <div className="grid2">
      {SKILL_LIST.map((s) => <button key={s.key} className="btn" aria-pressed={picked.has(s.key)}
        style={{ outline: picked.has(s.key) ? "2px solid var(--c-ink)" : "none", outlineOffset: -2 }} onClick={() => toggle(s.key)}>
        {s.name}<small>{s.blurb}</small></button>)}
    </div>
    <div className="seg" role="group" aria-label="Session length" style={{ margin: "16px 0 10px" }}>
      {[10, 20, 40].map((n) => <button key={n} aria-pressed={len === n} onClick={() => setLen(n)}>{n}</button>)}
    </div>
    <button className="btn-primary" disabled={!picked.size} onClick={() => nav("/play", { state: { mode: "focus", skills: [...picked], length: len }, replace: true })}>
      {picked.size ? `Start ${len} problems` : "Pick at least one skill"}
    </button>
  </main>;
}
